import type { ReactElement } from 'react';
import forms from '../admin/forms.module.css';
import styles from './DialogFooter.module.css';

export interface DialogFooterProps {
  /** Erro do envio. A região existe antes do texto, para o leitor de tela anunciá-lo quando chegar. */
  error: string | null;
  pending: boolean;
  submitLabel: string;
  onCancel: () => void;
}

/** Rodapé comum das janelas de modelo: aviso de erro, "Enviar" e "Cancelar". */
export function DialogFooter({
  error,
  pending,
  submitLabel,
  onCancel,
}: DialogFooterProps): ReactElement {
  return (
    <>
      <div aria-live="assertive" className={styles.slot}>
        {error && <p className={forms.alert}>{error}</p>}
      </div>
      <div className={forms.actions}>
        {/* aria-disabled (e não disabled): o botão focado não perde o foco ao enviar. */}
        <button
          type="submit"
          className={styles.primary}
          aria-disabled={pending || undefined}
          onClick={(event) => {
            if (pending) event.preventDefault();
          }}
        >
          {pending ? 'Enviando…' : submitLabel}
        </button>
        <button type="button" className={styles.secondary} disabled={pending} onClick={onCancel}>
          Cancelar
        </button>
      </div>
    </>
  );
}
